<template>
  <div class="spwwFooterPage">
    <div :class="{'device': device === 'mobile'}" class="mainCont">
      <div class="footer">
        <span style="padding-right: 5px;">{{ $t('copyright') }}</span>
        <a style="margin-left: 10px;" href="http://beian.miit.gov.cn" target="_blank">{{ $t('forTheRecord') }}</a>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
    device() {
      return this.$store.getters.device
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
  .spwwFooterPage {
    color: $menuActiveColor;
    text-align: center;
    margin-top: 10px;
    background-color: $menuBgcOragne;
    .mainCont {
      width: 1200px;
      &.device {
        width: 900px;
      }
      background-color: $menuBgcOragne;
      padding: 6px 0;
      margin: 0 auto;
      font-family: $fontFamilyArialMT;
      .footer {
        color: $menuActiveColor;
        font-size: 12px;
        a {
          color: $menuActiveColor;
        }
      }
    }
  }
</style>
